import PropTypes from 'prop-types';
import React from 'react';

const BadgeContainer = ({ children, position = 'top_left', ...props }) => {
	const positions = {
		top_left: 'left',
		top_right: 'right',
	};

	return (
		<>
			<div
				className={`badge-product-container badge-product-container-${positions[position]}`}
				{...props}
			>
				{children}
			</div>
		</>
	);
};

BadgeContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	position: PropTypes.string,
};

export default BadgeContainer;
